import React from 'react';
import LateralMenu from '../LateralMenu';
import { faCloudArrowUp, faCloudArrowDown } from '@fortawesome/free-solid-svg-icons';
import { translate } from '../../services/translate';
import logo from '../../../assets/logo_webrtc.png';
import collapsedLogo from '../../../assets/icon_cameras.png';

export default function WebRtcLateralMenu({ navigation, authenticatedUser, open, setOpen, selectedMenu }: LateralMenuProps) {
    const items = [{
        icon: faCloudArrowUp,
        text: translate('publisher'),
        action: () => navigation.navigate('WebRTC', { screen: 'Publisher' }),
        selected: selectedMenu == 'publisher'
    }, {
        icon: faCloudArrowDown,
        text: translate('consumer'),
        action: () => navigation.navigate('WebRTC', { screen: 'Consumer' }),
        selected: selectedMenu == 'consumer'
    },];

    return (
        <LateralMenu
            topImage={logo}
            collapsedTopImage={collapsedLogo}
            setOpen={setOpen}
            items={items}
            open={open}
            authenticatedUser={authenticatedUser}
        />
    );
}
